module.exports = __webpack_public_path__ + "assets/img/01a.b358aff0.jpg";